import { ActivatedRoute, ChildActivationStart, Router } from '@angular/router';
import  DataStatus from '../../../shared/models/datastatus.class';
import { HttpErrorResponse } from '@angular/common/http';
import { Component,  Input,  OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import AzureDevopsService from 'src/app/shared/services/azuredevops.service';
import { IAzureDevopsRepository } from '../../../shared/interfaces/azuredevops/repository.interface';

@Component({
  standalone: false,
  selector: 'app-pulumi-projects-list',
  templateUrl: './pulumi-projects-list.component.html',
  styleUrls: ['./pulumi-projects-list.component.css']
})
export class PulumiProjectsListComponent implements OnInit {
  public selectedRepositoryName!: string;

  public selectedRepositoryId!: string;

  public showEmptyState: boolean = true;

  public active!: number;

  public repositories = ["NiboAccountant", "NiboAccountantLegacy", "NiboFileApi", "NiboOrganization", "NiboOrganizationLegacy"]
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void { 
    this.activatedRoute.children[0]?.params
      .subscribe(() => {
        this.showEmptyState = false        
      });

    this.router.events
      .subscribe((event) => {       
          if(event instanceof ChildActivationStart) {
            this.showEmptyState = false            
          }
      });   
  } 
}